export function DecodeHex(hex) {
  if (!hex) {
    return '';
  }
  let decodedString = '';
  for (let i = 0; i < hex.length; i += 2) decodedString += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  return decodedString;
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/HexDecoder/HexDecoder.js